module.exports = __webpack_public_path__ + "static/media/tempo-to-symbol.7ef1ffab.svg";